var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"home1"}},[_c('navbar'),_c('hero-section'),_c('endorse'),_c('demands'),_c('protest-info'),_c('share-section'),_c('endorsements'),_c('contact'),_c('social'),_c('footer-section')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }